// Small formatters reused across pages.

export const formatSgDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-SG", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (err) {
    console.error("formatSgDateTime failed:", err);
    return iso;
  }
};

// Extract a user-friendly message from an axios/FastAPI error response.
export const extractApiErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  try {
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail) && detail[0]?.msg) {
      return String(detail[0].msg);
    }
    if (typeof detail === "string") {
      return detail;
    }
    if (err?.message && typeof err.message === "string") {
      return err.message;
    }
  } catch (parseErr) {
    console.error("extractApiErrorMessage failed to parse error:", parseErr);
  }
  return fallback;
};
